import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { ListItem } from "./ListItem";
import { ListContext } from "./ListContext";
import { ListDivider } from "./ListDivider";
import { useConfig } from "../_util/use-config";
export function List(_a) {
    var title = _a.title, footer = _a.footer, children = _a.children, className = _a.className, props = __rest(_a, ["title", "footer", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-list", className) }, props),
        typeof title !== "undefined" && (React.createElement(View, { className: classPrefix + "-list__title" }, title)),
        React.createElement(View, { className: classNames(classPrefix + "-list__wrap", {
            // [`${classPrefix}-hairline--${bordered || "horizontal"}`]: bordered,
            }) },
            React.createElement(ListContext.Provider, { value: {} }, children)),
        typeof footer !== "undefined" && (React.createElement(View, { className: classPrefix + "-list__footer" }, footer))));
}
List.Item = ListItem;
List.Divider = ListDivider;
//# sourceMappingURL=List.js.map